export default "https://cdn-static.gokick.com/assets/0f3104c02f0c7e58561d070a1e1ba5e916429e4c/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";